/**
 * Wrapper that triggers callback on scroll event. This function was created
 * To minimize the instantiation scroll events on the window object
 * @param {array} conditions - Array of conditions to loop
 * @params {func} condition.callback - Event triggered when scrolling
 **/
export const onScroll = function (conditions = []) {
	if (!conditions || (conditions && !conditions.length)) return;
	window.addEventListener('scroll', () => {
		conditions.forEach((condition) => {
			if (!condition.callback) return;
			condition.callback();
		});
	});
};
